module.exports = __webpack_public_path__ + "img/togo.e808e8cb.svg";